module.exports = __webpack_public_path__ + "img/db_btn.6899049b.png";